export default function LeadService($http) {
  let url = "/adminv2/api/selfSignUp/lead";

  this.save = function(contact) {
    var req = {
      method: contact.leadId ? "PUT" : "POST",
      url:    contact.leadId ? url + "/" + contact.leadId : url,
      data:   contact
    };

    return $http(req);
  };
}

export function LeadServiceStub($httpBackend) {
  $httpBackend
    .whenPOST('/adminv2/api/selfSignUp/lead')
    .respond(function(method, url, data) {
      return [200, "TODO", {/* response header */}];
    });
}




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-account/LeadService.js
 **/